/**
 * Created by puhui on 2016/12/12.
 */

require('./index.scss');
require('common/header/header.js');
require('common/css/footer.scss');
require('common/page/page.js');
//const moment = require('moment');
$(function (){
  //$('.article').find('p:lt(1)').remove();
  $(".news-content .news-item").each(function () {
    $(this).children('.article').find('p:lt(1)').remove();
  });
  $('.news-content .news-item').each(function () {
    $(this).find('.article').text($(this).find('.article').text());
  });

  $('.news-content>div').each(function () {
    var year=$(this).find('.time').text().substr(0,4);
    var month=$(this).find('.time').text().substr(5,2);
    var data=$(this).find('.time').text().substr(8,2);
    $(this).find('.time').text(year+'年'+month+'月'+data+'日');
  });

  $('.report-content>.report-item').each(function () {
    var year=$(this).find('.time span').text().substr(0,4);
    var month=$(this).find('.time span').text().substr(5,2);
    var data=$(this).find('.time span').text().substr(8,2);
    //alert('年'+year+'月'+month+'日'+data);
    $(this).find('.time').text(year+'年'+month+'月'+data+'日');
  });

  $('.news-content').children('div:eq(8)').css('borderBottom','none');
  $('.report-content').children('div:eq(6)').css('borderBottom','none');


  //分页开始 新闻动态
  /**
   *   $('.index ul li').click(function(){
    console.log($(this).index());
    $(this).attr('id','current-index');
    //location.search.split('=')[1]
  });
   *
   */
//pagenumber 为当前页码 //pagecount 为显示页数//endPoint 为显示几个页数
    //PageClick 为回调函数//pageclickednumber 为点击页码

  function geturlparam(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]); return null;
  }

  let page = geturlparam('page');
  $(".kkpager").pager({
     pagenumber:page,
     pagecount:6,
     buttonClickCallback:function(pageclickednumber){
       //console.log(pageclickednumber);
       location.href=location.href.split('?')[0]+'?page='+pageclickednumber;
       //$('.pages').children('li').removeClass('pgcurrent');
       //$('.pages').children('li:eq('+pageclickednumber+')').addClass('pgcurrent');
     }
   });

});


// WEBPACK FOOTER //
// ./static/news/index.js